module.exports = __webpack_public_path__ + "img/jabina.8b83e0f9.jpg";